import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable, BehaviorSubject, ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Orgunits } from './org.unit';
import { School } from '../dropdown-school/org.school';
import { Classroom } from '../dropdown-classroom/org.classroom';
import { District } from '../dropdown-district/org.district';
import { Area } from '../dropdown-area/org.area';
import { Subscription } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Title } from '@angular/platform-browser';
import { PhaseService } from '../_services/phase.service';
import { StudentService } from './student.service';
import { Router } from '@angular/router';
import { Role } from 'src/app/_helpers/roles';
@Injectable({
	providedIn: 'root',
})
export class OrgService {
	subscriptions: Subscription[] = [];
	decoded: any;
	headNode: any;
	nodeName: any;

	constructor(
		private http: HttpClient,
		private titleService: Title,
		private jwtHelper: JwtHelperService,
		private phaseService: PhaseService,
		private studentService: StudentService,
		private router: Router
	) {
		this._classrooms$ = new Subject();
		this._schools$ = new Subject();
		this._areas$ = new Subject();
		this._districts$ = new Subject();

		this._selectedClassroom$ = new BehaviorSubject<Classroom | null>(null);
		this._selectedSchool$ = new BehaviorSubject<School>(null);
		this._selectedArea$ = new Subject();
		this._selectedDistrict$ = new Subject();
	}

	private _districts$: Subject<District[]>;
	private _areas$: Subject<Area[]>;
	private _schools$: Subject<School[]>;
	private _classrooms$: Subject<Classroom[]>;
	public orgs: any;
	public gridApi = null;

	/** Emits once after {@link orgs} is populated from {@link orgs$} (replays for late subscribers). */
	private readonly orgsReadySubject = new ReplaySubject<void>(1);
	readonly orgsReady$ = this.orgsReadySubject.asObservable();

	private _selectedClassroom$: BehaviorSubject<Classroom | null>;
	private _selectedSchool$: BehaviorSubject<School>;
	private _selectedClassroomObj: Classroom;
	private _selectedArea$: Subject<Area>;
	private _selectedDistrict$: Subject<District>;

	selectedClassroom: any;
	selectedSchool: any;
	selectedArea: any;
	selectedDistrict: any;

	private initDone = false;

	init() {
		if (this.initDone) {
			return;
		}
		this.initDone = true;

		this.subscriptions.push(
			this.orgs$.subscribe((data: Orgunits) => {
				this.orgs = data.orgs;
				this.selectedClassroom = localStorage.getItem('selectedClassroom')
					? JSON.parse(localStorage.getItem('selectedClassroom'))
					: this.orgs.classrooms[0];
				this.selectedSchool = localStorage.getItem('selectedSchool')
					? JSON.parse(localStorage.getItem('selectedSchool'))
					: this.orgs.schools[0];

				this.selectedDistrict = localStorage.getItem('selectedDistrict')
					? JSON.parse(localStorage.getItem('selectedDistrict'))
					: this.orgs.districts[0];

				const targetAreas = this.orgs.areas.filter((area: Area) => area.district == this.selectedDistrict.id);
				if (targetAreas.length > 0) {
					this.selectedArea = localStorage.getItem('selectedArea')
						? JSON.parse(localStorage.getItem('selectedArea'))
						: targetAreas[0];
				}

				this._districts$.next(this.orgs.districts);
				this._areas$.next(this.orgs.areas.filter((area: any) => area.district == this.selectedDistrict.id));

				const targetDistrictsAreas = this.orgs.areas.filter((area: Area) => area.district == this.selectedDistrict.id);
				if (targetDistrictsAreas.length >= 2) {
					this._schools$.next(this.orgs.schools.filter((_school: School) => _school.area == this.selectedArea.id));
				} else {
					this._schools$.next(
						this.orgs.schools.filter((_school: School) => _school.district == this.selectedDistrict.id)
					);
				}
				this._classrooms$.next(
					this.orgs.classrooms.filter((_classroom: Classroom) => _classroom.schoolId == this.selectedSchool.id)
				);

				this._selectedDistrict$.next(this.selectedDistrict);
				this._selectedArea$.next(this.selectedArea);
				this._selectedSchool$.next(this.selectedSchool);

				if (this.orgs.classrooms) {
					this._selectedClassroomObj = this.selectedClassroom;
					this._selectedClassroom$.next(this.selectedClassroom);
					if (!localStorage.getItem('selectedClassroom')) {
						localStorage.setItem('selectedClassroom', JSON.stringify(this.orgs.classrooms[0]));
						localStorage.setItem('selectedSchool', JSON.stringify(this.orgs.schools[0]));
					}
				}
				if (this.orgs.districts) {
					if (!localStorage.getItem('selectedDistrict')) {
						localStorage.setItem('selectedDistrict', JSON.stringify(this.orgs.districts[0]));
					}
				}
				if (this.orgs.areas.filter((area: Area) => area.district == this.selectedDistrict.id).length > 0) {
					//This "area.district == district id" filter line is repeated several times. Should be done once every time district is changed and saved.
					if (!localStorage.getItem('selectedArea')) {
						localStorage.setItem(
							'selectedArea',
							JSON.stringify(this.orgs.areas[0] ? this.orgs.areas[0] : this.orgs.schools[0])
						);
					}
				}
				this.orgsReadySubject.next();
			})
		);

		window.addEventListener('beforeprint', (event) => {
			let currentSchool = this._selectedSchool$.getValue();
			let school = currentSchool?.name ? currentSchool.name : '';
			let tab = localStorage.getItem('activeTab');

			let date = new Date().toISOString().substring(0, 10);
			/*Date being the local machine's date could cause confusion if people grab this data while in distant other timezones.
			Maybe we should find the school/district's timezone and account for that */

			//Is Where
			let isStudentPage = this.router.url.toLowerCase().includes('/dashboard');
			console.log(this.router.url);
			let isClassroomTab = tab.includes('Classroom');

			//Classroom Name
			let classroom = '';
			if (isClassroomTab) {
				classroom = this._selectedClassroomObj
					? this._selectedClassroomObj.name
					: JSON.parse(localStorage.getItem('selectedClassroom')).name;
			}

			//Student Name
			let studentObj = this.studentService.getSelectedStudentAsObj();
			let student = '';
			if (isStudentPage) {
				student = studentObj.fname + ' ' + studentObj.lname;
			}

			let plex = tab;
			if (isClassroomTab && isStudentPage) {
				plex = student;
			} else if (isStudentPage) {
				plex = classroom;
			}

			this.titleService.setTitle(school + ' - ' + plex + ' - [' + date + ']');
		});

		window.addEventListener('afterprint', (event) => {
			this.titleService.setTitle('Progress Monitor');
		});
	}

	get orgs$(): Observable<Orgunits> {
		return this.http.get<Orgunits>(`${environment.apiUrl}/main/getOrgs/`);
	}

	tree$(nodeId: number, options?: { activeSessionsOnly?: boolean }): Observable<any> {
		let url = `${environment.apiUrl}/main/getTreeView/nodeId/${nodeId}`;
		if (options?.activeSessionsOnly) {
			const sep = url.indexOf('?') >= 0 ? '&' : '?';
			url = `${url}${sep}activeSessionsOnly=1`;
		}
		return this.http.get<any>(url);
	}

	get districts$() {
		return this._districts$.asObservable();
	}

	get areas$() {
		return this._areas$.asObservable();
	}

	get schools$() {
		return this._schools$.asObservable();
	}

	get classrooms$() {
		return this._classrooms$.asObservable();
	}

	get selectedSchool$() {
		return this._selectedSchool$.asObservable().pipe(
			// filter to make sure the value is not null before it is emitted
			filter((school: School | null) => school !== null)
		);
	}

	get selectedClassroom$() {
		return this._selectedClassroom$.asObservable();
	}

	get selectedArea$() {
		return this._selectedArea$.asObservable();
	}

	get selectedDistrict$() {
		return this._selectedDistrict$.asObservable();
	}
	setGridApi(grids) {
		this.gridApi = grids;
	}

	clearGrids() {
		if (Array.isArray(this.gridApi)) {
			this.gridApi.forEach(function (grid) {
				grid.setPinnedBottomRowData([]);
				grid.showNoRowsOverlay();
			});
		}
	}

	setClassroom(classroom: Classroom) {
		localStorage.setItem('selectedClassroom', JSON.stringify(classroom));
		this._selectedClassroom$.next(classroom);
		this._selectedClassroomObj = classroom;
		localStorage.removeItem('selectedStudent');
	}

	setSchool(school: School) {
		this.clearGrids();
		let classrooms = this.orgs.classrooms.filter((_classroom: Classroom) => _classroom.schoolId == school.id);
		console.log(this.orgs.classrooms[0]);
		this._classrooms$.next(classrooms);
		this._selectedClassroom$.next(classrooms[0]);
		this._selectedSchool$.next(school);

		localStorage.setItem('selectedClassroom', JSON.stringify(classrooms[0]));
		localStorage.setItem('selectedSchool', JSON.stringify(school));
	}

	setArea(area: any, setSchool: boolean = true) {
		this.clearGrids();
		let schools = this.orgs.schools.filter((_school: School) => _school.area == area.id);

		let classrooms = this.orgs.classrooms.filter((_classroom: Classroom) => _classroom.schoolId == schools[0].id);

		console.log('setDistrict', classrooms);
		console.log('setDistrict', schools[0]);

		this._selectedArea$.next(area);
		if (setSchool) {
			this._selectedSchool$.next(schools[0]);
		}
		this._schools$.next(schools);
		this._classrooms$.next(classrooms);
		this._selectedClassroom$.next(classrooms[0]);

		localStorage.setItem('selectedClassroom', JSON.stringify(classrooms[0]));
		if (setSchool) {
			localStorage.setItem('selectedSchool', JSON.stringify(schools[0]));
		}
		localStorage.setItem('selectedArea', JSON.stringify(area));
	}

	setDistrict(district: any) {
		this.clearGrids();
		let areas = this.orgs.areas.filter((area: Area) => area.district == district.id);
		if (areas.length <= 2) {
			localStorage.removeItem('selectedArea');
		}

		let schools;
		if (areas.length >= 2) {
			schools = this.orgs.schools.filter((_school: School) => _school.area == areas[0].id);
		} else {
			schools = this.orgs.schools.filter((_school: School) => _school.district == district.id);
		}

		if (localStorage.getItem('selectedArea')) {
			let a = JSON.parse(localStorage.getItem('selectedArea'));
			schools = this.orgs.schools.filter((_school: School) => _school.area == a.id);
		} else if (areas.length > 0) {
			this.setArea(areas[0]);
		}

		let classrooms = this.orgs.classrooms.filter((_classroom: Classroom) => _classroom.schoolId == schools[0].id);

		this._districts$.next(this.orgs.districts);
		this._selectedDistrict$.next(district);
		this._schools$.next(schools);
		this._selectedSchool$.next(schools[0]);

		if (this.orgs.areas.length >= 2) {
			this._areas$.next(areas);
		}
		this._classrooms$.next(classrooms);

		this._selectedClassroom$.next(classrooms[0]);

		localStorage.setItem('selectedDistrict', JSON.stringify(district));

		localStorage.setItem('selectedSchool', JSON.stringify(schools[0]));
		localStorage.setItem('selectedClassroom', JSON.stringify(classrooms[0]));
	}

	getClassroomAsObj() {
		console.log(this._selectedClassroomObj);
		return this._selectedClassroomObj;
	}
	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	getHeadNode() {
		const token = localStorage.getItem('currentUser');
		this.decoded = this.jwtHelper.decodeToken(token);
		console.log('node--', this.decoded);

		let selectedClassroom = localStorage.getItem('selectedClassroom')
			? JSON.parse(localStorage.getItem('selectedClassroom'))
			: this.orgs?.classrooms[0];
		let selectedSchool = localStorage.getItem('selectedSchool')
			? JSON.parse(localStorage.getItem('selectedSchool'))
			: this.orgs?.schools[0];
		let selectedArea = localStorage.getItem('selectedArea')
			? JSON.parse(localStorage.getItem('selectedArea'))
			: this.orgs?.areas[0];
		let selectedDistrict = localStorage.getItem('selectedDistrict')
			? JSON.parse(localStorage.getItem('selectedDistrict'))
			: this?.orgs?.districts[0];

		if (this?.orgs?.districts >= 1) {
			this.headNode = selectedDistrict.districtId;
			this.nodeName = selectedDistrict.name;
		} else if (this?.orgs?.areas >= 1) {
			this.headNode = selectedArea.id;
			this.nodeName = selectedArea.name;
		} else if (this?.orgs?.school >= 1) {
			this.headNode = selectedSchool.id;
			this.nodeName = selectedSchool.name;
		} else {
			this.headNode = selectedClassroom.id;
			this.nodeName = selectedClassroom.name;
		}
		console.log('Role', this.decoded.role);
		console.log('Role', this.decoded);
		return { nodeId: this.headNode, name: this.nodeName };
	}
}
